export var ConsentAccountSubtype;
(function (ConsentAccountSubtype) {
    ConsentAccountSubtype["CHECKING_ACCOUNT"] = "CHECKING_ACCOUNT";
    ConsentAccountSubtype["SAVINGS_ACCOUNT"] = "SAVINGS_ACCOUNT";
    ConsentAccountSubtype["CREDIT_CARD"] = "CREDIT_CARD";
})(ConsentAccountSubtype || (ConsentAccountSubtype = {}));
export function getCheckingAccounts(accounts) {
    return (accounts ?? []).filter(account => account.subtype === ConsentAccountSubtype.CHECKING_ACCOUNT);
}
export function getAccountIdentification(account) {
    const transferNumber = account.bankData?.transferNumber ?? '';
    const parts = transferNumber.split('/').map(part => part.trim());
    const [, branch, number] = parts;
    if (parts.length === 3 && parts.every(Boolean)) {
        return { branchNumber: account.branchNumber || branch, number };
    }
    return { branchNumber: account.branchNumber || undefined, number: account.number };
}
export var ConsentBankState;
(function (ConsentBankState) {
    ConsentBankState["VALIDATING"] = "VALIDATING";
    ConsentBankState["VALID"] = "VALID";
    ConsentBankState["INVALID"] = "INVALID";
    ConsentBankState["PENDING_ADDITIONAL_CONFIRMATION"] = "PENDING_ADDITIONAL_CONFIRMATION";
    ConsentBankState["PENDING"] = "PENDING";
    ConsentBankState["ERROR"] = "ERROR";
    ConsentBankState["CONNECTING"] = "CONNECTING";
    ConsentBankState["CONNECTED"] = "CONNECTED";
    ConsentBankState["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ConsentBankState["PENDING_DEVICE_ENABLED"] = "PENDING_DEVICE_ENABLED";
    ConsentBankState["CONNECTION_CLOSED"] = "CONNECTION_CLOSED";
    ConsentBankState["WAITING_SECOND_SIGNATURE"] = "WAITING_SECOND_SIGNATURE";
    ConsentBankState["PENDING_MULTIPLE_SIGNATURES"] = "PENDING_MULTIPLE_SIGNATURES";
    ConsentBankState["REDO_CONSENTMENT"] = "REDO_CONSENTMENT";
})(ConsentBankState || (ConsentBankState = {}));
export var ConsentStatusCode;
(function (ConsentStatusCode) {
    ConsentStatusCode["CONNECTED"] = "CONNECTED";
    ConsentStatusCode["CONNECTING"] = "CONNECTING";
    ConsentStatusCode["PENDING_MULTIPLE_SIGNATURES"] = "PENDING_MULTIPLE_SIGNATURES";
    ConsentStatusCode["CONNECTION_CLOSED"] = "CONNECTION_CLOSED";
    ConsentStatusCode["UNKNOWN"] = "UNKNOWN";
    ConsentStatusCode["ACCOUNT_INVALID_CREDENTIALS"] = "ACCOUNT_INVALID_CREDENTIALS";
    ConsentStatusCode["USER_AUTHORIZATION_PENDING"] = "USER_AUTHORIZATION_PENDING";
    ConsentStatusCode["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    ConsentStatusCode["USER_AUTHORIZATION_NOT_GRANTED"] = "USER_AUTHORIZATION_NOT_GRANTED";
    ConsentStatusCode["USER_AUTHORIZATION_REVOKED"] = "USER_AUTHORIZATION_REVOKED";
    ConsentStatusCode["USER_NOT_SUPPORTED"] = "USER_NOT_SUPPORTED";
    ConsentStatusCode["ACCOUNT_CREDENTIALS_RESET"] = "ACCOUNT_CREDENTIALS_RESET";
    ConsentStatusCode["CONNECTION_ERROR"] = "CONNECTION_ERROR";
    ConsentStatusCode["ACCOUNT_PENDING_ISSUES"] = "ACCOUNT_PENDING_ISSUES";
    ConsentStatusCode["CONNECTION_TIMEOUT"] = "CONNECTION_TIMEOUT";
})(ConsentStatusCode || (ConsentStatusCode = {}));
export var ConsentConnectionStatus;
(function (ConsentConnectionStatus) {
    ConsentConnectionStatus["CONNECTING"] = "CONNECTING";
    ConsentConnectionStatus["CONNECTED"] = "CONNECTED";
    ConsentConnectionStatus["CONNECTION_CLOSED"] = "CONNECTION_CLOSED";
})(ConsentConnectionStatus || (ConsentConnectionStatus = {}));
export var ConsentSyncStatus;
(function (ConsentSyncStatus) {
    ConsentSyncStatus["SYNCING"] = "SYNCING";
    ConsentSyncStatus["SYNCED"] = "SYNCED";
    ConsentSyncStatus["WITH_ISSUES"] = "WITH_ISSUES";
})(ConsentSyncStatus || (ConsentSyncStatus = {}));
export var OpenFinanceBankTypes;
(function (OpenFinanceBankTypes) {
    OpenFinanceBankTypes["BANCO_DO_BRASIL"] = "BANCO_DO_BRASIL";
    OpenFinanceBankTypes["BANRISUL"] = "BANRISUL";
    OpenFinanceBankTypes["BRADESCO"] = "BRADESCO";
    OpenFinanceBankTypes["CAIXA"] = "CAIXA";
    OpenFinanceBankTypes["ITAU"] = "ITAU";
    OpenFinanceBankTypes["NUBANK"] = "NUBANK";
    OpenFinanceBankTypes["SANTANDER"] = "SANTANDER";
    OpenFinanceBankTypes["SICOOB"] = "SICOOB";
    OpenFinanceBankTypes["SICREDI"] = "SICREDI";
    OpenFinanceBankTypes["UNICRED"] = "UNICRED";
    OpenFinanceBankTypes["PLUGGY"] = "PLUGGY";
    OpenFinanceBankTypes["INTER"] = "INTER";
    OpenFinanceBankTypes["C6_BANK"] = "C6_BANK";
})(OpenFinanceBankTypes || (OpenFinanceBankTypes = {}));
export var BelvoTokenStatusEnum;
(function (BelvoTokenStatusEnum) {
    BelvoTokenStatusEnum["application_link"] = "application_link";
    BelvoTokenStatusEnum["success"] = "success";
    BelvoTokenStatusEnum["event"] = "event";
    BelvoTokenStatusEnum["exit"] = "exit";
})(BelvoTokenStatusEnum || (BelvoTokenStatusEnum = {}));
export var OpenFinanceFeedbackEnum;
(function (OpenFinanceFeedbackEnum) {
    OpenFinanceFeedbackEnum["APPLICATION_LINK"] = "application-link";
    OpenFinanceFeedbackEnum["SUCCESS"] = "success";
    OpenFinanceFeedbackEnum["EXIT"] = "exit";
    OpenFinanceFeedbackEnum["EVENT"] = "event";
})(OpenFinanceFeedbackEnum || (OpenFinanceFeedbackEnum = {}));
export var ConsentPartner;
(function (ConsentPartner) {
    ConsentPartner["PLUGGY"] = "PLUGGY";
    ConsentPartner["BELVO"] = "BELVO";
})(ConsentPartner || (ConsentPartner = {}));
export var ConsentTransactionType;
(function (ConsentTransactionType) {
    ConsentTransactionType["PIX"] = "PIX";
    ConsentTransactionType["TRANSFERENCE"] = "TRANSFERENCE";
    ConsentTransactionType["BILL"] = "BILL";
})(ConsentTransactionType || (ConsentTransactionType = {}));
export var ConsentTransactionTypeEnum;
(function (ConsentTransactionTypeEnum) {
    ConsentTransactionTypeEnum["CREDIT"] = "CREDIT";
    ConsentTransactionTypeEnum["DEBIT"] = "DEBIT";
})(ConsentTransactionTypeEnum || (ConsentTransactionTypeEnum = {}));
